import { create } from 'zustand';

import { ProjectTaskType } from '../lib/types';

type ProjectLoadingTaskState = {
  actionBeforePolling: (() => Promise<void>) | null;
  isInitialized: boolean;
  isTrialEditorOpen: boolean;
  projectLoadingTask: null | ProjectTaskType;
};

type ProjectLoadingTaskStateActions = {
  resetProjectLoadingState: () => void;
  setIsTrialEditorOpen: (isTrialEditorOpen: boolean) => void;
  updateProjectLoadingState: (newState: {
    actionBeforePolling?: ProjectLoadingTaskState['actionBeforePolling'];
    projectLoadingTask: ProjectLoadingTaskState['projectLoadingTask'];
  }) => void;
};

const defaultState = {
  actionBeforePolling: null,
  isInitialized: false,
  isTrialEditorOpen: false,
  projectLoadingTask: null,
} satisfies ProjectLoadingTaskState;

export const useProjectLoadingTaskStore = create<ProjectLoadingTaskState & ProjectLoadingTaskStateActions>((set) => ({
  ...defaultState,
  resetProjectLoadingState: () => set(defaultState),
  setIsTrialEditorOpen: (isTrialEditorOpen) => set({ isTrialEditorOpen }),
  updateProjectLoadingState: ({ actionBeforePolling, projectLoadingTask }) =>
    set(() => ({ actionBeforePolling: actionBeforePolling || null, isInitialized: true, projectLoadingTask })),
}));
